import useUserStore from "../stores/userStore";
import api from "./api";

export const communityService = {
  getCommunity: async () => {
    try {
      const response = await api.get(
        `/mapi/community/getCommunity?EntityId=699ETIGY-50HU5K80-GN58S3ZE`
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching community data:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getCommunityDetails: async (communityId) => {
    try {
      const entityId = "699ETIGY-50HU5K80-GN58S3ZE"; // Fixed Entity ID
      const response = await api.get(
        `/mapi/community/getCommunityById?EntityId=${entityId}&CommunityId=${communityId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching community data:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  editCommunityDetails: async (communityData) => {
    try {
      console.log("Editing Community:", communityData);

      const response = await api.post(
        `/mapi/community/editCommunity`,
        communityData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error updating community details:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  addCommunity: async (communityData) => {
    try {
      const requestData = {
        EntityId: "699ETIGY-50HU5K80-GN58S3ZE",
        ...communityData,
        Status: "A",
      };

      console.log("Adding Community:", requestData);

      const response = await api.post(
        `/mapi/community/addCommunity`,
        requestData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error adding new community:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  addCommunityWithEmails: async (communityData, emails) => {
    try {
      const requestData = {
        EntityId: "699ETIGY-50HU5K80-GN58S3ZE",
        ...communityData,
        Emails: emails,
        Status: "A",
      };

      console.log("Adding Community with Emails:", requestData);

      const response = await api.post(
        `/mapi/community/addCommunityWithEmails`,
        requestData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error adding community with emails:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  removeCommunity: async (communityId) => {
    try {
      const OperatorId = useUserStore.getState().userId; // Get the OperatorId from the user store
      console.log("operatorid: ", OperatorId);

      const requestData = {
        OperatorId,
        CommunityId: communityId,
      };

      console.log("Removing Community with data:", requestData);

      const response = await api.post(
        `/mapi/community/removeCommunity`,
        requestData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error removing community:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default communityService;
